import { GlButton, GlButtonGroup, GlDisclosureDropdown, GlTooltipDirective } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { sprintf, s__ } from '~/locale';
import { setUrlParams, relativePathToAbsolute, getBaseURL } from '~/lib/utils/url_utility';
import { isMarkdownFilePath } from '../utils';
import { BTN_COPY_CONTENTS_TITLE, BTN_DOWNLOAD_TITLE, BTN_DOWNLOAD_AS_MARKDOWN_TITLE, BTN_DOWNLOAD_AS_PDF_TITLE, BTN_RAW_TITLE, RICH_BLOB_VIEWER, SIMPLE_BLOB_VIEWER } from './constants';
export default {
    name: 'BlobHeaderDefaultActions',
    i18n: {
        BTN_DOWNLOAD_AS_MARKDOWN_TITLE,
        BTN_DOWNLOAD_AS_PDF_TITLE
    },
    components: {
        GlButtonGroup,
        GlButton,
        GlDisclosureDropdown
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    inject: {
        blobHash: {
            default: ''
        },
        canDownloadCode: {
            default: true
        },
        fileType: {
            default: ''
        }
    },
    props: {
        rawPath: {
            type: String,
            required: true
        },
        activeViewer: {
            type: String,
            default: SIMPLE_BLOB_VIEWER,
            required: false
        },
        hasRenderError: {
            type: Boolean,
            required: false,
            default: false
        },
        isBinary: {
            type: Boolean,
            required: false,
            default: false
        },
        environmentName: {
            type: String,
            required: false,
            default: null
        },
        environmentPath: {
            type: String,
            required: false,
            default: null
        },
        isEmpty: {
            type: Boolean,
            required: false,
            default: false
        },
        overrideCopy: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: [
        'copy'
    ],
    computed: {
        downloadUrl () {
            return setUrlParams({
                inline: false
            }, {
                url: relativePathToAbsolute(this.rawPath, getBaseURL())
            });
        },
        copyDisabled () {
            return this.activeViewer === RICH_BLOB_VIEWER;
        },
        getBlobHashTarget () {
            if (this.overrideCopy) {
                return null;
            }
            return `[data-blob-hash="${this.blobHash}"]`;
        },
        showCopyButton () {
            return !this.hasRenderError && !this.isBinary;
        },
        environmentTitle () {
            return sprintf(s__('BlobViewer|View on %{environmentName}'), {
                environmentName: this.environmentName
            });
        },
        isPdfFile () {
            return this.fileType?.includes('pdf');
        },
        isMarkdownFile () {
            return isMarkdownFilePath(this.rawPath?.split('?')[0]);
        },
        showDownloadDropdown () {
            return !this.isEmpty && this.canDownloadCode && this.isMarkdownFile;
        },
        downloadDropdownItems () {
            return [
                {
                    text: this.$options.i18n.BTN_DOWNLOAD_AS_MARKDOWN_TITLE,
                    href: this.downloadUrl,
                    // eslint-disable-next-line @gitlab/require-i18n-strings
                    extraAttrs: {
                        rel: 'noopener noreferrer'
                    }
                },
                {
                    text: this.$options.i18n.BTN_DOWNLOAD_AS_PDF_TITLE,
                    action: ()=>{
                        document.querySelectorAll('img').forEach((img)=>img.setAttribute('loading', 'eager'));
                        document.querySelectorAll('details').forEach((detail)=>detail.setAttribute('open', ''));
                        window.print();
                    }
                }
            ];
        },
        openInNewWindowUrl () {
            return setUrlParams({
                inline: true
            }, {
                url: relativePathToAbsolute(this.rawPath, getBaseURL())
            });
        }
    },
    methods: {
        onCopy () {
            if (this.overrideCopy) {
                this.$emit('copy');
            }
        }
    },
    BTN_COPY_CONTENTS_TITLE,
    BTN_DOWNLOAD_TITLE,
    BTN_RAW_TITLE
};
